import * as React from "react";
import { TextArea } from "semantic-ui-react";
import "./labeled-textarea.css";

export default function LabeledTextArea({
                                            label,
                                            name,
                                            defaultValue = null,
                                            disabled = false,
                                        }: {
    label: string;
    name: string;
    defaultValue?: string | null;
    disabled?: boolean;
}): JSX.Element {
    return (
        <div className="labeledTextArea">
            <span>{label}</span>
            <TextArea
                name={name}
                rows="6"
                defaultValue={defaultValue}
                disabled={disabled}
            />
        </div>
    );
}
